import { combineReducers } from 'redux';
import purchaseMode from './purchaseMode';
import type { PurchaseMode } from './purchaseMode';

export type Settings = {
  purchaseMode: PurchaseMode;
};

export default combineReducers({
  purchaseMode,
});
